import React from "react";
import Icon from "@mdi/react";
import ReadingMask from "../../ReadingMask";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { mdiWheelchairAccessibility } from "@mdi/js";
import PageStructure from "../../PageStructure/PageStructure";
import { translation } from "../../Language";
const MUI = React.forwardRef(({ children, mouseYPosition = 0, isOpen = false, classes = [], handleMouseMove = () => { }, setIsOpen = () => { }, links = [], headings = [], handleReset = () => { }, language = "en", features = [], resetDisabled = false, }, ref) => {
    const bigCursor = features.filter((f) => f.featureName === "BIG_CURSOR" /* Types.BIG_CURSOR */).length > 0 &&
        features.filter((f) => f.featureName === "BIG_CURSOR" /* Types.BIG_CURSOR */)[0].feature;
    const readingMask = features.filter((f) => f.featureName === "READING_MASK" /* Types.READING_MASK */).length > 0 &&
        features.filter((f) => f.featureName === "READING_MASK" /* Types.READING_MASK */)[0].feature;
    return (React.createElement(Box, { className: bigCursor ? "cursor" : "", onMouseMove: (event) => handleMouseMove(event), style: {
            maxWidth: "100vw",
            minHeight: "100vh",
        }, ref: ref },
        readingMask && (React.createElement(ReadingMask, { mousePosition: mouseYPosition })),
        isOpen && (React.createElement(Grid, { className: "left-bar", flexDirection: "column", height: "100%", width: "40%", justifyContent: "flex-start", sx: {
                border: "1px solid gray",
                backgroundColor: "#eff1f5",
                zIndex: 9999,
                position: "fixed !important",
                top: 0,
                left: 0,
                overflow: "auto",
            } },
            React.createElement(Grid, { container: true, width: "100%", flexDirection: "row" },
                React.createElement(Grid, { container: true, item: true, flexDirection: "row", justifyContent: "space-between", xs: 12, sx: {
                        marginBottom: "2px",
                    } },
                    React.createElement(Grid, { item: true, xs: 8, sx: {
                            paddingLeft: "5px",
                        } },
                        React.createElement(Typography, { variant: "caption" },
                            translation[language].accessibilityMenu,
                            "(ctrl + u)")),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Button, { variant: "text", disabled: resetDisabled, fullWidth: true, onClick: () => handleReset(), "aria-label": translation[language].reset }, translation[language].reset))),
                features.map((f, index) => (React.createElement(Grid, { container: true, item: true, xs: 12, sm: 12, md: 6, flexDirection: "column", alignItems: "center", "aria-label": f.text, sx: {
                        minHeight: "125px",
                        height: "auto",
                    } },
                    React.createElement(Button, { variant: "outlined", fullWidth: true, onClick: () => f.handler(), sx: {
                            backgroundColor: f.feature ? "#87B922" : "white",
                            borderColor: f.feature ? "#fff" : "#000",
                            color: f.feature ? "#fff" : "#000",
                            borderRadius: "20px",
                            padding: "inherit",
                            height: "100%",
                        }, className: `accessibility-button`, tabIndex: index + 1 },
                        React.createElement(Stack, { direction: "column", width: "100%", alignItems: "center", gap: "2px" },
                            React.createElement(Box, null, f.icon),
                            React.createElement(Box, null,
                                React.createElement(Typography, { variant: "button" }, f.text)))))))))),
        React.createElement(Button, { onClick: () => setIsOpen(!isOpen), sx: {
                cursor: bigCursor ? "inherit" : "pointer",
                left: isOpen ? "41%" : "0",
                color: "black",
                position: "fixed",
            }, variant: "outlined", className: "disabled-person-button" },
            React.createElement(Icon, { path: mdiWheelchairAccessibility, size: 2 })),
        React.createElement(Box, { className: classes.join(" ") }, children),
        features.filter((f) => f.featureName === "PAGE_STRUCTURE" /* Types.PAGE_STRUCTURE */).length >
            0 && (React.createElement(PageStructure, { isOpen: features.filter((f) => f.featureName === "PAGE_STRUCTURE" /* Types.PAGE_STRUCTURE */)[0]
                .feature, links: links, headings: headings, onClose: features.filter((f) => f.featureName === "PAGE_STRUCTURE" /* Types.PAGE_STRUCTURE */)[0]
                .handler, language: language, bigCursor: bigCursor }))));
});
// eslint-disable-next-line react-refresh/only-export-components
export default MUI;
//# sourceMappingURL=MUI.js.map